import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { SET_PLAYBACK_RATE, SET_QUALITY, SET_SUBTITLE } from '../actions';
const defaultState = {};
const settingsReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_PLAYBACK_RATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        playbackRate: action.playbackRate
      });
    case SET_QUALITY:
      return _objectSpread(_objectSpread({}, state), {}, {
        quality: action.quality
      });
    case SET_SUBTITLE:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedSubtitle: action.selectedSubtitle
      });
    default:
      return state;
  }
};
export default settingsReducer;